document.addEventListener('click', function(e) {
  if (e.target && e.target.id === 'btn-redeem-merch') {
    const customerId = e.target.getAttribute('data-customer-id');
    const variantId = e.target.getAttribute('data-product-id');
    const originalText = e.target.innerText;
    
    // Bloqueamos el botón para evitar dobles clics
    e.target.innerText = "PROCESANDO...";
    e.target.disabled = true;

    // Petición POST a tu Backend/Middleware
    fetch('https://URL-DE-TU-MIDDLEWARE/api/canjear', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        customerId: customerId, 
        variantId: variantId 
      })
    })
    .then(response => response.json())
    .then(data => {
      if(data.success && data.invoice_url) {
        // Todo fue un éxito, redirigimos al checkout gratuito
        window.location.href = data.invoice_url;
      } else {
        alert("Hubo un error al procesar el canje: " + data.message);
        e.target.innerText = originalText;
        e.target.disabled = false;
      }
    })
    .catch(error => {
      console.error('Error:', error);
      e.target.innerText = originalText;
      e.target.disabled = false;
    });
  }
});